import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getTimezoneDate } from 'utils/date'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import MenuItem from 'material-ui/MenuItem'

import { doc, dirtyRead } from 'selectors/common'
import { termsByPropertyID } from 'selectors/lease'
import { propertiesEx } from 'selectors/properties'

import Section from 'components/Section'
import dataActions from 'actions/dataActions'
import AddButton from 'components/AddButton'
import EventList from './List'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , terms: termsByPropertyID(state, props)
	  , events: propertiesEx(state)[props.propertyID]
	})
)

export class Events extends Component{
	render(){
		let { props } = this
		let lastTerm=props.terms && props.terms.length && props.terms[props.terms.length-1]
		let availableFrom= props.property && props.property.availFrom && getTimezoneDate(props.property.availableFrom) || new Date()

		return(
			<Section
				id="property/events"
				title="History"
				rightButton={
					<AddButton>
						<MenuItem value="listing"
							disabled={props.events && props.events.status && props.events.status.forRent=='For Rent'}
							object={{
									type:"listing"
								  , propertyID: props.propertyID
								  , rent: lastTerm.rent
								  , securityDeposit: lastTerm.securityDeposit
								  , petDeposit: lastTerm.petDeposit
								  , availableFrom: "" + availableFrom.getFullYear()+'-'+(availableFrom.getMonth()+1<10 ? "0" : "")+(availableFrom.getMonth()+1)+'-'+(availableFrom.getDate()<10 ? "0" : "")+availableFrom.getDate()
								  , dateFrom:  "" + new Date().getFullYear()+'-'+(new Date().getMonth()+1<10 ? "0" : "")+(new Date().getMonth()+1)+'-'+(new Date().getDate()<10 ? "0" : "")+new Date().getDate()
								}}
							 primaryText="Listing"
						 />
						 <MenuItem
						 	value="application"
							disabled={props.events && props.events.status && props.events.status.forRent!='For Rent'}
							primaryText="Application"
							object={{alias: props.property.alias}}
							act={props.NEW_APPLICATION}
 						 />
						 <MenuItem value="retired"
 							object={{
 									_id: props.propertyID
								  , dateTill:  "" + new Date().getFullYear()+'-'+(new Date().getMonth()+1<10 ? "0" : "")+(new Date().getMonth()+1)+'-'+(new Date().getDate()<10 ? "0" : "")+new Date().getDate()
 								}}
 							 primaryText="Retired"
							 act={props.STAGE}
 						 />
					</AddButton>
				}
			>
				<EventList propertyID={props.propertyID} />
			</Section>
		)
	}
}

export default connect(select, dataActions)(Events)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/events/index.js